<div
  *ngIf="size === 'lg'"
  class="avatar-wrapper"
  ngbPopoverClass="popover-custom"
  placement="top"
  [ngbPopover]="title"
  triggers="mouseenter:mouseleave"
>
  <span class="circle-image-lg member-avatar default-pointer" *ngIf="imageUrl && !imageLoadError">
    <img [src]="imageUrl" (error)="handleImageError()" />
  </span>
  <span class="circle-lg member-avatar default-pointer" *ngIf="!imageUrl || imageLoadError">{{ nick?.toUpperCase()?.substring(2, 0) }}</span>
</div>
<div
  *ngIf="size !== 'lg'"
  class="avatar-wrapper"
  ngbPopoverClass="popover-custom"
  placement="top"
  [ngbPopover]="title"
  triggers="mouseenter:mouseleave"
>
  <span class="circle-image-md member-avatar default-pointer" *ngIf="imageUrl && !imageLoadError">
    <img [src]="imageUrl" (error)="handleImageError()" />
  </span>
  <span class="circle-md member-avatar default-pointer" *ngIf="!imageUrl || imageLoadError">{{ nick?.toUpperCase()?.substring(2, 0) }}</span>
</div>
